import { render, staticRenderFns } from "./q3.vue?vue&type=template&id=a960f34c&scoped=true&"
import script from "./q3.vue?vue&type=script&lang=js&"
export * from "./q3.vue?vue&type=script&lang=js&"
import style0 from "./q3.vue?vue&type=style&index=0&id=a960f34c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a960f34c",
  null
  
)

export default component.exports